
// spark product card script start


// spark product card script End



//Proffesional stimbrushes product page faq toggle js
function toggleFAQ(button) {
          let faqItem = button.parentElement;
          let faqAnswer = faqItem.querySelector(".faq-answer");
          let icon = button.querySelector(".faq-icon");

          if (faqItem.classList.contains("open")) {
              faqItem.classList.remove("open");
              faqAnswer.style.display = "none";
              icon.textContent = "+";
          } else {
              // Close all FAQs first
              document.querySelectorAll(".faq-item").forEach(item => {
                  item.classList.remove("open");
                  item.querySelector(".faq-answer").style.display = "none";
                  item.querySelector(".faq-icon").textContent = "+";
              });

              // Open the clicked one
              faqItem.classList.add("open");
              faqAnswer.style.display = "block";
              icon.textContent = "−";
          }
      }

    //   stimbrushe media gallery
 var ct_brush_slider = new Swiper('.ct_brush_slider', {
    loop:true,
    slidesPerView: 4,
    spaceBetween: 30,
    // centeredSlides: true,
    freeMode: true,
    autoplay: {
        delay: 3000, 
        disableOnInteraction: false, 
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1.3,
            spaceBetween: 0,
            freeMode: false,
        },
        550: {
            slidesPerView: 3,
            spaceBetween: 0,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 30,
        }
    }
});